import { render } from "./MessageFilterResult.vue?vue&type=template&id=46518dc4&scoped=true"
import script from "./MessageFilterResult.vue?vue&type=script&lang=js"
export * from "./MessageFilterResult.vue?vue&type=script&lang=js"

import "./MessageFilterResult.vue?vue&type=style&index=0&id=46518dc4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46518dc4"]])

export default __exports__